import { Box, Container, Paper, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ReactElement } from 'react';

const useStyles = makeStyles({
  root: {
    height: '50vh',
  },
});

export const NoResultsCard = (): ReactElement => {
  const classes = useStyles();

  return (
    <Container>
      <Box sx={{ m: 3, mt: 5 }}>
        <Paper classes={classes}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
            <Typography>No Results</Typography>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};
